module.exports = __webpack_public_path__ + "img/logo-m2n.811437e7.svg";